export default __webpack_public_path__ + "static/media/ALL BAGS.467f8841.jpg";